
import responseFormatter from './responseFormatter';

const FORM_MODE_ADD  = 'add';
const FORM_MODE_EDIT = 'edit';

export default class FormSubmitter {

    constructor(options) {

        this._validateOptions(options);

        this.create = options.create;
        this.update = options.update;

        this.createSuccess = options.createSuccess || options.submitSuccess || this._requestSuccess;
        this.createFailed  = options.createFailed  || options.submitFailed  || this._requestFailed;

        this.updateSuccess = options.updateSuccess || options.submitSuccess || this._requestSuccess;
        this.updateFailed  = options.updateFailed  || options.submitFailed  || this._requestFailed;
    }

    getSubmit(formMode = FORM_MODE_ADD) {

        if (formMode === FORM_MODE_ADD) {

            return this._submitCreate.bind(this);

        } else if (formMode === FORM_MODE_EDIT) {

            return this._submitUpdate.bind(this);
        }
    }

    _requestSuccess(response) {

        return response;
    }

    _requestFailed(response) {

        throw responseFormatter.apiErrorsToFormErrors(response.data.errors);
    }

    _submitUpdate(values) {

        return this.update(values)
            .then(this.updateSuccess, this.updateFailed);
    }

    _submitCreate(values) {

        return this.create(values)
            .then(this.createSuccess, this.createFailed);
    }

    _validateOptions(options) {

        if (typeof options.create !== 'function') {

            throw 'A create function must be specified.';
        }

        if (typeof options.update !== 'function') {

            throw 'An update function must be specified.';
        }
    }
}


// WEBPACK FOOTER //
// ./services/formSubmitter.js